import { render, staticRenderFns } from "./PaginaPresidi.vue?vue&type=template&id=e7925216&"
import script from "./PaginaPresidi.vue?vue&type=script&lang=js&"
export * from "./PaginaPresidi.vue?vue&type=script&lang=js&"
import style0 from "./PaginaPresidi.vue?vue&type=style&index=0&id=e7925216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports